import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { CapacitySort } from "@planzone/dto";

import { ArrowIcon } from "@common/assets/arrowIcon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import styles from "./styles.scss";

const SORT_OPTIONS: CapacitySort[] = [
  "ALPHABETICAL",
  "ROLE",
  "CREATION_DATE",
  "TYPE",
];

const SORT_LABELS: { [key in CapacitySort]: string } = {
  ALPHABETICAL: "capacityPage.sorters.alphabetical",
  ROLE: "capacityPage.sorters.role",
  CREATION_DATE: "capacityPage.sorters.creationDate",
  TYPE: "capacityPage.sorters.type",
};

function SortDropdown(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.sortDropdown}>
      <p className={styles.title}>{t("capacityPage.toolbar.sortTitle")}</p>
      <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
        {({ isOpen, select }) => ({
          input: (
            <div
              className={classNames(styles.input, {
                [styles.opened]: isOpen,
              })}
            >
              <p>{t(SORT_LABELS[props.sort])}</p>
              <ArrowIcon className={styles.icon} />
            </div>
          ),
          list: (
            <div className={styles.list}>
              {SORT_OPTIONS.map((option) => (
                <div
                  key={option}
                  className={classNames(styles.option, {
                    [styles.selected]: props.sort === option,
                  })}
                  onClick={() => select(props.setSort(option))}
                >
                  <p>{t(SORT_LABELS[option])}</p>
                </div>
              ))}
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { SortDropdown };
